module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-4 pb-4"
  }, [_c('ul', {
    staticClass: "mx-0 d-flex row justify-content-center flex-wrap"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "d-flex col-auto"
    }, [(item.description) ? _c('AppTooltip', {
      attrs: {
        "maxWidth": "200px",
        "top": "top",
        "color": "#09f"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('a', _vm._g(_vm._b({
            attrs: {
              "href": item.url ? item.url : ''
            }
          }, 'a', attrs, false), on), [(item.image) ? _c('AppPicture', {
            staticClass: "partners__pictiure",
            attrs: {
              "image": item.image,
              "image-height": "100px"
            }
          }) : _vm._e()], 1)]
        }
      }], null, true)
    }, [(item.description) ? _c('span', {
      staticClass: "ui_color__white"
    }, [_vm._v(_vm._s(item.description))]) : _vm._e()]) : _c('a', {
      attrs: {
        "href": item.url ? item.url : ''
      }
    }, [(item.image) ? _c('AppPicture', {
      staticClass: "partners__pictiure",
      attrs: {
        "image": item.image,
        "image-height": "100px",
        "image-width": "initial"
      }
    }) : _vm._e()], 1)], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-788744f7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/partners/Partners.vue
// module id = 60f7ddac82f15035edb4
// module chunks = 0